import { render } from "./Start.vue?vue&type=template&id=4509d799"
import script from "./Start.vue?vue&type=script&lang=js"
export * from "./Start.vue?vue&type=script&lang=js"

import "./Start.vue?vue&type=style&index=0&id=4509d799&lang=css"
script.render = render

export default script